import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { AnalyticsService } from '@app/core/analytics/analytics.service';
import { EventOriginEnum, NavigateToEnum } from '@app/core/enums/analytics/analytics-value.enum';

@Component({
    selector: 'notification-popup',
    templateUrl: './notification-popup.component.html',
    styleUrls: ['./notification-popup.component.scss'],
    standalone: false
})
export class NotificationPopupComponent {
  protected readonly message = inject<{ newFeatureMessage: string }>(MAT_SNACK_BAR_DATA).newFeatureMessage;
  private readonly snackBarRef = inject<MatSnackBarRef<NotificationPopupComponent>>(MatSnackBarRef);
  private readonly analyticsService = inject(AnalyticsService);

  public dismiss(): void {
    this.snackBarRef.dismiss();
    this.analyticsService.trackNavigationEvent(EventOriginEnum.NOTIFICATION_POPUP, NavigateToEnum.CLOSE_NOTIFICATION);
  }

  public reloadPage(): void {
    window.location.reload();
  }

}
